<template>
	<nav style="--bs-breadcrumb-divider: url(&#34;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='%236c757d'/%3E%3C/svg%3E&#34;);">
		<ol class="breadcrumb border-bottom p-3">
			<li class="breadcrumb-item">
				<router-link :to="{path: '/'}" class="text-decoration-none">Главная</router-link>
			</li>
			<li class="breadcrumb-item">
				<router-link :to="{path: '/users'}" class="text-decoration-none">Пользователи</router-link>
			</li>
			<li class="breadcrumb-item active">Изменение пользователя</li>
		</ol>
	</nav>
	<div class="container-fluid">
		<div class="mb-3">
			<h5>Изменение пользователя</h5>
			<div class="text-muted">Редактирование информации о пользователе с указанием прав доступа к проектам и причастности к группам пользователей</div>
		</div>
		<div class="d-flex justify-content-center mt-5" v-if="init">
			<div class="spinner-border" style="width: 100px; height: 100px;"></div>
		</div>
		<div class="d-flex justify-content-center mt-5" v-if="!init && !user.id">
			<div class="text-center">
				<h4 class="text-uppercase mt-4">404</h4>
				<p class="text-muted">Пользователь не найден</p>
				<div class="mt-4">
					<router-link :to="{path: '/users'}" class="btn btn-primary waves-effect waves-light">Перейти к списку</router-link>
				</div>
			</div>
		</div>
		<form @submit.prevent="saveChanges" v-if="!init && user.id">
			<div class="row">
				<div class="col-md-2 mb-3">
					<div class="card">
						<div class="card-header">Аватар</div>
						<div class="card-body text-center">
							<div v-if="previewAva || oldAva">
								<image-with-placeholder
									:src="previewAva || oldAva"
									class="mw-100 ratio ratio-1x1 rounded mb-2"
									height="100%"
									skeleton="shimmer"
									alt="ava"
								/>
							</div>
							<div>
								<img src="/assets/images/noimage2.png" />
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-5 mb-3">
					<div class="card">
						<div class="card-header">Параметры пользователя</div>
						<div class="card-body">
							<div class="mb-3">
								<label class="form-label">Логин</label>
								<div class="d-flex align-items-center form-control">
									<code>{{ user.login }}</code>
								</div>
							</div>
							<div class="mb-3">
								<label for="inputPassword" class="form-label">Новый пароль</label>
								<div class="input-group">
									<input class="form-control font-monospace" :type="passwordShow ? 'text' : 'password'" id="inputPassword" :disabled="loading" v-model="user.password" />
									<button class="btn btn-outline-secondary px-2" type="button" :disabled="loading" @click="passwordShow = !passwordShow">
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
											<path v-if="passwordShow" d="M2,5.27L3.28,4L20,20.72L18.73,22L15.65,18.92C14.5,19.3 13.28,19.5 12,19.5C7,19.5 2.73,16.39 1,12C1.69,10.24 2.79,8.69 4.19,7.46L2,5.27M12,9A3,3 0 0,1 15,12C15,12.35 14.94,12.69 14.83,13L11,9.17C11.31,9.06 11.65,9 12,9M12,4.5C17,4.5 21.27,7.61 23,12C22.18,14.08 20.79,15.88 19,17.19L17.58,15.76C18.94,14.82 20.06,13.54 20.82,12C19.17,8.64 15.76,6.5 12,6.5C10.91,6.5 9.84,6.68 8.84,7L7.3,5.47C8.74,4.85 10.33,4.5 12,4.5M3.18,12C4.83,15.36 8.24,17.5 12,17.5C12.69,17.5 13.37,17.43 14,17.29L11.72,15C10.29,14.85 9.15,13.71 9,12.28L5.6,8.87C4.61,9.72 3.78,10.78 3.18,12Z" />
											<path v-else d="M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9M12,4.5C17,4.5 21.27,7.61 23,12C21.27,16.39 17,19.5 12,19.5C7,19.5 2.73,16.39 1,12C2.73,7.61 7,4.5 12,4.5M3.18,12C4.83,15.36 8.24,17.5 12,17.5C15.76,17.5 19.17,15.36 20.82,12C19.17,8.64 15.76,6.5 12,6.5C8.24,6.5 4.83,8.64 3.18,12Z" />
										</svg>
									</button>
								</div>
								<small class="text-muted">Указать только в том случае, когда его нужно сменить!</small>
							</div>
							<div class="mb-2 row">
								<div class="col-6">
									<label class="form-check-label" for="switchIsAdmin">Админ</label>
									<div class="form-check form-switch">
										<input class="form-check-input" type="checkbox" role="switch" id="switchIsAdmin" v-model="user.isAdmin" :disabled="loading" />
									</div>
								</div>
								<div class="col-6">
									<label class="form-check-label" for="switchIsBlocked">Блок</label>
									<div class="form-check form-switch">
										<input class="form-check-input" type="checkbox" role="switch" id="switchIsBlocked" v-model="user.isBlocked" :disabled="loading" />
									</div>
								</div>
							</div>
							<div>
								<label for="inputAvatar" class="form-label">Аватар</label>
								<input ref="fileInput" class="form-control" type="file" id="inputAvatar" accept="image/*" @change="onFileChange" :disabled="loading" />
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-5 mb-3">
					<div class="card">
						<div class="card-header">Причастность к группам</div>
						<div class="card-body">
							<div class="input-group mb-3">
								<input type="text" class="form-control" placeholder="Поиск по группам" v-model="searchGroups" :disabled="loading" />
								<button class="btn btn-outline-secondary d-flex align-items-center px-2" type="button" :disabled="loading" @click="searchGroups = ''" v-if="searchGroups">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
										<path d="M16.24,3.56L21.19,8.5C21.97,9.29 21.97,10.55 21.19,11.34L12,20.53C10.44,22.09 7.91,22.09 6.34,20.53L2.81,17C2.03,16.21 2.03,14.95 2.81,14.16L13.41,3.56C14.2,2.78 15.46,2.78 16.24,3.56M4.22,15.58L7.76,19.11C8.54,19.9 9.8,19.9 10.59,19.11L14.12,15.58L9.17,10.63L4.22,15.58Z" />
									</svg>
								</button>
							</div>
							<div class="form-check">
								<input class="form-check-input" type="checkbox" checked disabled />
								<label class="badge text-bg-primary font-monospace">@all</label>
							</div>
							<div class="form-check" v-for="group in filteredGroups" :key="group.id">
								<input class="form-check-input" type="checkbox" :value="group.id" :id="'checkGroup' + group.id" v-model="user.groups" :disabled="loading" />
								<label class="badge text-bg-dark font-monospace" :for="'checkGroup' + group.id">@{{ group.name }}</label>
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-12 mb-3">
					<div class="card">
						<div class="card-header">Права доступа к проектам</div>
						<div class="card-body">
							<div class="input-group mb-3">
								<input type="text" class="form-control" placeholder="Поиск по проектам" :disabled="loading" v-model="searchProjects" />
								<button class="btn btn-outline-secondary d-flex align-items-center px-2" type="button" :disabled="loading" @click="searchProjects = ''" v-if="searchProjects">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
										<path d="M16.24,3.56L21.19,8.5C21.97,9.29 21.97,10.55 21.19,11.34L12,20.53C10.44,22.09 7.91,22.09 6.34,20.53L2.81,17C2.03,16.21 2.03,14.95 2.81,14.16L13.41,3.56C14.2,2.78 15.46,2.78 16.24,3.56M4.22,15.58L7.76,19.11C8.54,19.9 9.8,19.9 10.59,19.11L14.12,15.58L9.17,10.63L4.22,15.58Z" />
									</svg>
								</button>
							</div>
							<div class="row">
								<div class="col-md-3" v-for="project in filteredProjects" :key="project.id">
									<div class="form-check">
										<input v-if="user.isAdmin" class="form-check-input" type="checkbox" :id="'checkProject' + project.id" checked disabled />
										<input v-else class="form-check-input" type="checkbox" :value="project.id" :id="'checkProject' + project.id" :disabled="loading" v-model="user.projects" />
										<label class="badge text-bg-warning font-monospace" :for="'checkProject' + project.id" v-tippy="{placement: 'top', content: project.name}">{{ project.apiname }}</label>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="card">
				<div class="card-body">
					<div class="d-grid gap-2 d-md-flex justify-content-md-between">
						<button
							type="button"
							class="btn btn-danger d-flex align-items-center justify-content-center"
							@click="deleteUser"
							:disabled="loading"
						>
							<span v-if="loading && loadingDelete" class="spinner-border spinner-border-sm me-2"></span>
							<svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
								<path d="M9,3V4H4V6H5V19A2,2 0 0,0 7,21H17A2,2 0 0,0 19,19V6H20V4H15V3H9M7,6H17V19H7V6M9,8V17H11V8H9M13,8V17H15V8H13Z" />
							</svg>
							<span class="ms-2">{{ loading && loadingDelete ? 'Удаление...' : 'Удалить пользователя' }}</span>
						</button>
						<button
							type="submit"
							class="btn btn-primary d-flex align-items-center justify-content-center"
							:disabled="loading"
						>
							<span v-if="loading && loadingSave" class="spinner-border spinner-border-sm me-2"></span>
							<svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
								<path d="M15,9H5V5H15M12,19A3,3 0 0,1 9,16A3,3 0 0,1 12,13A3,3 0 0,1 15,16A3,3 0 0,1 12,19M17,3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V7L17,3Z" />
							</svg>
							<span class="ms-2">{{ loading && loadingSave ? 'Сохранение...' : 'Сохранить изменения' }}</span>
						</button>
					</div>
				</div>
			</div>
		</form>
	</div>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';
import { useModal } from "vue-final-modal";

import ImageWithPlaceholder from '@/components/ImageWithPlaceholder.vue';
import BootstrapConfirmModal from "@/components/modals/BootstrapConfirmModal.vue";

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'Изменение пользователя | SKV'});
	},
	data: () => ({
		init: false,
		loading: false,
		loadingSave: false,
		loadingDelete: false,
		passwordShow: false,
		groups: [],
		projects: [],
		searchGroups: '',
		searchProjects: '',
		previewAva: '',
		oldAva: '',
		selectedFile: null,
		user: {
			id: null,
			login: '',
			password: '',
			isAdmin: false,
			isBlocked: false,
			groups: [],
			projects: [],
		},
	}),
	computed: {
		filteredGroups(){
			const search = this.searchGroups.toLowerCase();
			return this.groups.filter(group => group.name.toLowerCase().includes(search));
		},
		filteredProjects(){
			const search = this.searchProjects.toLowerCase();
			return this.projects.filter(project =>
				project.name.toLowerCase().includes(search) ||
				project.apiname.toLowerCase().includes(search)
			);
		},
	},
	methods: {
		getAvatar(user) {
			if (!user?.avatar) return '';
			return `/files/avatar/${user.avatar}`;
		},
		onFileChange(e) {
			const file = e.target.files[0];
			if (!file || !file.type.match('image.*')) {
				if (file) this.$toast.warning('Пожалуйста, выберите изображение');
				this.resetFile();
				return;
			}

			this.selectedFile = file; // Сохраняем "модель"
			if (this.previewAva) URL.revokeObjectURL(this.previewAva);
			this.previewAva = URL.createObjectURL(file);
		},
		resetFile() {
			this.selectedFile = null;
			this.previewAva = '';
			if (this.$refs.fileInput) {
				this.$refs.fileInput.value = ''; // Очистка системного инпута
			}
		},
		async loadData() {
			this.loading = true;
			try {
				const userId = this.$route.params.id;
				// Загружаем всё параллельно: группы, проекты и сам пользователь
				const [groups, projects, userRes] = await Promise.all([
					this.appModel.doGetUserGroups({all: true}),
					this.appModel.doGetProjects({all: true}),
					this.appModel.doGetUser(userId),
				]);
				this.groups = groups.list || [];
				this.projects = projects.list || [];
				
				// Преобразуем полученные данные группы под формат чекбоксов (массивы ID)
				if (userRes) {
					this.user = {
						id: userRes.id,
						login: userRes.login,
						isAdmin: userRes.is_admin,
						isBlocked: userRes.is_blocked,
						projects: userRes.direct_projects.map(p => p.id),
						groups: userRes.groups.map(p => p.id),
					};
					this.oldAva = this.getAvatar(userRes);
				}
			} catch (e) {
				console.error(e);
			} finally {
				this.loading = false;
			}
		},
		
		async saveChanges() {
			this.loading = true;
			this.loadingSave = true;
			try {
				const formData = new FormData();
				
				formData.append('id', this.user.id);
				if (this.user.password) {
					formData.append('password', this.user.password);
				}
				formData.append('is_admin', this.user.isAdmin ? 1 : 0);
				formData.append('is_blocked', this.user.isBlocked ? 1 : 0);
				
				if (this.selectedFile) {
					formData.append('avatar_file', this.selectedFile);
				}

				this.user.groups?.forEach(id => {
					formData.append('groups[]', id);
				});
				
				this.user.projects?.forEach(id => {
					formData.append('projects[]', id);
				});

				const result = await this.appModel.doEditUser(this.user.id, formData);
				if (!result.success) {
					this.$toast.error(result.message);
				}
			} finally {
				this.loading = false;
				this.loadingSave = false;
			}
		},
		async deleteUser() {
			useModal({
				component: BootstrapConfirmModal,
				attrs: {
					title: "Удаление пользователя",
					centered: true,
					confirmText: "Удалить пользователя",
					confirmColor: "danger",
					onConfirm: async () => {
						this.loading = true;
						this.loadingDelete = true;
						try {
							const result = await this.appModel.doDeleteUser(this.user.id);
							if (result.success) {
								await this.appModel.refreshCounts();
								
								this.$router.push('/users');
							} else {
								this.$toast.error(result.message);
							}
						} finally {
							this.loading = false;
							this.loadingDelete = false;
						}
					},
				},
				slots: {
					default: `Вы уверены, что хотите безвозвратно удалить пользователя "${this.user.login}"?`,
				},
			}).open();
		},
	},
	async mounted() {
		this.init = true;
		await this.loadData();
		this.init = false;
	},
	components: {
		ImageWithPlaceholder,
	},
};
</script>
